import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
  const store = useAuthStore()
  if (!store.canCreateChangeOrder) {
    return navigateTo({ name: 'dashboard' })
  }

  return null
})
